export enum MarketplaceTabGroup {
    Engagement = 1,
    DealWorkspace = 2,
    ClosingAndBeyond = 3,
    Administration = 4,
}

export interface GroupedTab {
    group: MarketplaceTabGroup;
}

export const GROUP_END_TAB_CLASS = 'RRT__tab--group-end';

export const isLastTabOfGroup = (
    visibleTabs: GroupedTab[],
    index: number
): boolean =>
    index >= 0 &&
    index < visibleTabs.length - 1 &&
    visibleTabs[index].group !== visibleTabs[index + 1].group;

export const groupDividerClass = (
    visibleTabs: GroupedTab[],
    index: number
): string =>
    isLastTabOfGroup(visibleTabs, index) ? ` ${GROUP_END_TAB_CLASS}` : '';
